import { checkpointSchedule } from "@/lib/format";
import { localOf } from "@/sentinel";

/** A scheduled checkpoint cutoff: ET first, then the viewer's local time, always labelled. */
export const CheckpointTime = ({ sessionDate, cutoffET, testId }) => {
  const schedule = checkpointSchedule(sessionDate, cutoffET);
  return (
    <span className="sn-small" style={{ display: "block", minWidth: 0 }} data-testid={testId}>
      <span className="sn-num" style={{ display: "block", color: "var(--text-primary)" }} data-testid={`${testId}-et`}>
        {cutoffET ? `${cutoffET} ET` : "Scheduled cutoff unavailable"}
      </span>
      <span className="sn-faint" style={{ display: "block" }} data-testid={`${testId}-sydney`}>
        Local · <span className="sn-sans-num">{cutoffET ? localOf(cutoffET, { day: sessionDate }) : schedule?.sydney || "time unavailable"}</span>
      </span>
    </span>
  );
};
